module.exports = __webpack_public_path__ + "static/media/pain_au_lait.0c70d53a.JPG";